import { useTranslator } from '@bluebeam/react-i18n';
import {
  MapOverlayMachineEventsEnum,
  useMapOverlayMachine,
} from 'components/Overlays/MapOverlayMachine';
import OverlayHeader from 'components/Overlays/OverlayHeader';
import OverlayViewerContainer from 'components/Overlays/OverlayViewerContainer';
import AppStoreContext from 'contexts/AppStoreContext';
import Immutable from 'immutable';
import React, { useContext } from 'react';
import { ViewMapPunchList } from 'records/interactions/ViewMapPunchList';
import { ViewPunchList } from 'records/interactions/ViewPunchList';
import PunchList from './PunchList';

type ViewPunchListOverlayProps = {
  interaction: ViewPunchList | ViewMapPunchList;
};

const ViewPunchListOverlay: React.FC<ViewPunchListOverlayProps> = ({
  interaction,
}) => {
  const { translate } = useTranslator(['mapView']);
  const { actions } = useContext(AppStoreContext);
  const { mapOverlayMachineService } = useMapOverlayMachine();

  const handleCancelClick = (): void => {
    if (interaction.type === 'ViewMapPunchList') {
      mapOverlayMachineService.send(MapOverlayMachineEventsEnum.CLOSE_OVERLAY);
    } else {
      actions.clearInteractions();
    }
  };

  const isMapPunch = interaction.type === 'ViewMapPunchList';

  const title = isMapPunch
    ? translate('mapView:viewPunchListOverlay.punches')
    : `${translate('mapView:viewPunchListOverlay.punchItems')} - ${
        (interaction as ViewPunchList).sheet.sheetid
      }`;

  const listSheets = isMapPunch
    ? (interaction as ViewMapPunchList).sheets
    : Immutable.List([(interaction as ViewPunchList).sheet]);

  return (
    <OverlayViewerContainer
      id="view-punch-list-overlay"
      style={interaction.containerStyles}
    >
      <OverlayHeader
        id="view-punch-list-overlay-header"
        title={title}
        onCancelClick={handleCancelClick}
      />
      <PunchList
        sheets={listSheets}
        resetPunchQuery={(interaction as ViewPunchList).resetPunchQuery}
        isOnMap={isMapPunch}
      />
    </OverlayViewerContainer>
  );
};

export default ViewPunchListOverlay;
